import { Group, Text, Box } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { ConfigContext } from 'src/app/ConfigContext';
import * as Icons from 'src/assets';
import { DOCS_LINK } from 'src/constants';

export function LayoutFooter() {
  const { config } = useContext(ConfigContext);
  const FooterLogo = Icons[config.footerLogo as keyof typeof Icons];

  return (
    <Group h="100%" justify="space-between">
      <Box w={220}>
        <FooterLogo className="h-8" />
      </Box>

      <Group gap={36}>
        <Link target="_blank" to={config.termsOfServiceUrl}>
          <Text c="#E8E8E8">Terms of Service</Text>
        </Link>
        <Link target="_blank" to={config.privacyPolicyUrl}>
          <Text c="#E8E8E8">Privacy Policy</Text>
        </Link>
        <Link target="_blank" to={DOCS_LINK}>
          <Text c="#E8E8E8">Documentation</Text>
        </Link>
        <Link target="_blank" to="https://job-boards.greenhouse.io/apr">
          <Text c="#E8E8E8">Careers</Text>
        </Link>
      </Group>
    </Group>
  );
}
